import { Option } from '@Components/types/options';
import { SponsorTypeCodes } from '@Enum/api/SponsorTypeCodes.enum';

type Output = {
  batchNo: string;
  wagesMonth: string;
};

export const mapSponsoredByExtraField = (
  sponsoredBy: string,
  sponsoredByExtra: string,
  companiesOptions: Option[]
): Output => {
  if (sponsoredBy !== String(SponsorTypeCodes.COMPANY)) {
    const output = {
      batchNo: sponsoredByExtra,
      wagesMonth: '',
    };
    return output;
  }

  const companyLabel = companiesOptions.find(
    (item) => item.value === sponsoredByExtra
  )?.label;

  const output = {
    batchNo: companyLabel || '',
    wagesMonth: sponsoredByExtra,
  };
  return output;
};
